exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1HkHSCQbDUMGkh{height:269px;width:260px;margin-bottom:24px;margin-right:24px}._26zpIVes_BL66x{width:auto}._26zpIVes_BL66x,.CTw93AKo6KAVf3{height:132px;border-radius:3px;position:relative}.CTw93AKo6KAVf3{content:\" \";box-shadow:0 4px 8px rgba(9,30,66,.25);transition:opacity .2s ease-in-out;width:100%;margin-top:-132px}._1o4JM6-RR5FFm0{position:relative;margin-top:-36px;padding-left:12px;padding-bottom:12px;padding-right:12px}._3FFVzNono4qv3F{background-color:#fff;border:3px solid #fff;box-shadow:0 1px 1px rgba(9,45,66,.25)}.VKkYxBLsNHymp8{border-radius:3px}._1z-D-N_3Zq0B_-{line-height:12px}.xBh18OUs8H670s{margin-top:12px;font-size:14px;line-height:20px;color:#172b4d;font-weight:700}._3gf5uhzv3ryrEm{font-size:12px;line-height:20px;color:#6b778c}._3WwXguV1bqQJjG{font-size:12px;line-height:20px;color:#172b4d}._3k2wZq15oMJAJQ{cursor:pointer}._2Cj26rHQQ7u9Yy{text-decoration:none}", ""]);

// exports
exports.locals = {
	"trelloBlue": "#0079BF",
	"templateLink": "_1HkHSCQbDUMGkh",
	"templateBackground": "_26zpIVes_BL66x",
	"templateBackgroundAfter": "CTw93AKo6KAVf3",
	"templateInfo": "_1o4JM6-RR5FFm0",
	"avatar": "_3FFVzNono4qv3F",
	"orgAvatar": "VKkYxBLsNHymp8",
	"memberAvatar": "_1z-D-N_3Zq0B_-",
	"title": "xBh18OUs8H670s",
	"author": "_3gf5uhzv3ryrEm",
	"blurb": "_3WwXguV1bqQJjG",
	"cursor": "_3k2wZq15oMJAJQ",
	"allText": "_2Cj26rHQQ7u9Yy"
};